export type Unit = 'BY' | 'KB' | 'MB' | 'GB' | 'TB' | 'PB';

const units: Unit[] = ['BY', 'KB', 'MB', 'GB', 'TB', 'PB'];

export const bytesAs = (bytes = 0, precision: Unit = 'MB'): number => {
  const unitIndex = units.indexOf(precision);

  if (unitIndex === -1) {
    throw new RangeError(`Unit wasn't provided`);
  }

  return Math.round((bytes / 1024 ** unitIndex) * 100) / 100;
};
